/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react/no-unescaped-entities */
import { useCallback, useState } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { useDownloadVpnConfig } from 'src/common/hooks/use-download-vpn-config';
import { ReactComponent as AppleIcon } from 'src/images/svgs/brands/apple.svg';
import { ReactComponent as LinuxIcon } from 'src/images/svgs/brands/linux.svg';
import { ReactComponent as WindowsIcon } from 'src/images/svgs/brands/windows.svg';
import { StyledTitle } from '../access-networks.styles';
import { HavingProblems, LinuxContent, MacOsContent, WindowsContent } from './components';
import { StyledButton, StyledLink, StyledVpnOptions, StyledWrapperButtons } from './open-vpn-options.styles';
export const OpenVpnOptions = () => {
  const [activeContent, setActiveContent] = useState('linux'); // Set the default active content

  const networkId = useAppSelector(state => state.room.networkDetails?._id);
  const {
    handleDownloadVpnConfig,
    isDownloadLoading
  } = useDownloadVpnConfig(networkId);
  const handleContentChange = useCallback((newContent: string) => {
    setActiveContent(newContent);
  }, []);
  return <StyledVpnOptions data-testid="open-vpn-screen" data-sentry-element="StyledVpnOptions" data-sentry-component="OpenVpnOptions" data-sentry-source-file="open-vpn-options.tsx">
      <StyledLink to="/access" data-link="main" target="_blank" rel="noopener noreferrer" data-sentry-element="StyledLink" data-sentry-source-file="open-vpn-options.tsx">
        View the dedicated OpenVPN access page for more information
      </StyledLink>

      <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="open-vpn-options.tsx">What Operating System are you using?</StyledTitle>
      <StyledWrapperButtons data-sentry-element="StyledWrapperButtons" data-sentry-source-file="open-vpn-options.tsx">
        <StyledButton onClick={() => handleContentChange('windows')} data-active={activeContent === 'windows' ? 'open' : 'close'} variant="outlined" data-sentry-element="StyledButton" data-sentry-source-file="open-vpn-options.tsx">
          <WindowsIcon data-sentry-element="WindowsIcon" data-sentry-source-file="open-vpn-options.tsx" />
          Windows
        </StyledButton>

        <StyledButton onClick={() => handleContentChange('linux')} data-active={activeContent === 'linux' ? 'open' : 'close'} variant="outlined" data-sentry-element="StyledButton" data-sentry-source-file="open-vpn-options.tsx">
          <LinuxIcon data-sentry-element="LinuxIcon" data-sentry-source-file="open-vpn-options.tsx" />
          Linux
        </StyledButton>

        <StyledButton onClick={() => handleContentChange('mac')} data-active={activeContent === 'mac' ? 'open' : 'close'} variant="outlined" data-sentry-element="StyledButton" data-sentry-source-file="open-vpn-options.tsx">
          <AppleIcon data-sentry-element="AppleIcon" data-sentry-source-file="open-vpn-options.tsx" />
          MacOS
        </StyledButton>
      </StyledWrapperButtons>

      {activeContent === 'windows' && <WindowsContent isLoading={isDownloadLoading} downloadHandler={handleDownloadVpnConfig} />}
      {activeContent === 'linux' && <LinuxContent isLoading={isDownloadLoading} downloadHandler={handleDownloadVpnConfig} />}
      {activeContent === 'mac' && <MacOsContent isLoading={isDownloadLoading} downloadHandler={handleDownloadVpnConfig} />}
      <HavingProblems data-sentry-element="HavingProblems" data-sentry-source-file="open-vpn-options.tsx" />
    </StyledVpnOptions>;
};